import moment from 'moment';
import React from 'react';
import voca from 'voca';
import showAlert from '../../../common/utils/alert';
import TooltipInfo from '../../../common/docs/TooltipInfo';
import { description } from '../../../common/utils/event_constants';

export const FileTable = ({ files, deleteAction, projectId, version, deleteFlag }) => {
  const handleDelete = (uuid) => {
    const preConfirm = () => {
      deleteAction({ uuid, projectId, version });
    };
    const message = `This will remove all the related CSS, JS, Images and HTML. You won't be able to revert it!`;
    showAlert(message, preConfirm, 'Yes, delete it!');
  };
  if (!files || files.length === 0) return <div className="alert"> No Files</div>;
  return (
    <table className="table table-bordered table-word-break">
      <thead>
        <tr>
          <th>#</th>
          <th>Name</th>
          <th>Status</th>
          <th>Created At</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {files.map((file, index) => (
          <tr key={index}>
            <td>{index + 1}</td>
            <td>{file.name}</td>
            <td>{voca.titleCase(file.status)}</td>
            <td>{moment(file.createdAt).format('Do MMM YYYY hh:mm:ss A')}</td>
            <td>
              &nbsp;
              <button
                type="button"
                className="btn btn-theme-delete btn-xs"
                style={{ cursor: deleteFlag ? 'pointer' : 'not-allowed' }}
                title="Delete Item"
                onClick={() => (deleteFlag ? handleDelete(file.uuid) : undefined)}
              >
                <i className="wb webconnect-trash-regular" /> &nbsp;
                {deleteFlag ? null : (
                  <TooltipInfo
                    title={description}
                    headerText={`Permission Disabled!`}
                    showHeader={true}
                    showArrow={true}
                  />
                )}
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
